import { type ReactNode } from 'react';
import { useT } from '../i18n';
import '../styles/screens.css';

interface LandingScreenProps {
  onCreateRoom: () => void;
  onJoinRoom: () => void;
}

export function LandingScreen({ onCreateRoom, onJoinRoom }: LandingScreenProps): ReactNode {
  const t = useT();
  return (
    <div className="landing-container">
      <h1 className="landing-title">{t('landing.title')}</h1>
      <p className="landing-subtitle">{t('landing.subtitle')}</p>
      <div className="landing-actions">
        <button className="btn btn--primary" onClick={onCreateRoom}>
          {t('landing.createRoom')}
        </button>
        <button className="btn btn--secondary" onClick={onJoinRoom}>
          {t('landing.joinRoom')}
        </button>
      </div>
    </div>
  );
}
